import "./Home.css";
import { config } from "./App";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Input } from "antd";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import FormHelperText from "@mui/material/FormHelperText";
import { CircularProgress } from "@mui/material";
import {
  Grid,
  Box,
  Button,
  Typography,
  IconButton,
  FormControl,
  TextField,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import Header from "./Header";
import Dashboard from "./Dashboard";
import { useSnackbar } from "notistack";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { pink } from "@mui/material/colors";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/700.css";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
const Home = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [videos, setVideos] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(0);
  const { Search } = Input;
  const [filteredVideo, setFilteredVideo] = useState([]);
  const [activeGenres, setActiveGenres] = useState(true);
  const [dateValue, setDateValue] = useState(moment("2022-08-18T21:11:54"));
  const [active, setActive] = useState(["all"]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enteredLink, setEnteredLink] = useState("");
  const [enteredThumbnail, setEnteredThumbnail] = useState("");
  const [enteredTitle, setEnteredTitle] = useState("");
  const [sortBy, setSortBy] = useState("releaseDate");
  const searchParam = ["title"]
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [activeRating, setActiveRating] = useState([]);
  const [allGenres, setAllGenres] = useState([
    { label: "All", value: "all" },
    { label: "Education", value: "Education" },
    { label: "Sports", value: "Sports" },
    { label: "Comedy", value: "Comedy" },
    { label: "Lifestyle", value: "Lifestyle" },
  ]);
  const [allContentRatings, setAllContentRatings] = useState([
    { label: "Anyone", value: "Anyone" },
    { label: "7+", value: "7+" },
    { label: "12+", value: "12+" },
    { label: "16+", value: "16+" },
    { label: "18+", value: "18+" },
  ]);

  const [selectGenre, setSelectGenre] = useState("");
  const [selectContentRating, setSelectContentRating] = useState("");
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#383838",
    color: "#FFFFFF",
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
  };

  const modalStyle = {
    color: "#FFFFFF",
    cursor: "pointer",
  };
  const fetchVideos = async () => {
    setLoading(true);
    let url = `${config.linked}`;
    if (searchText?.length > 0) {
      url += `?title=${searchText}`;
      url += `&sortBy=${sortBy}`;
    } else {
      url += `?sortBy=${sortBy}`;
    }
  
    try {
      let response = await axios.get(url);
      setLoading(false);
      const videos = response.data.videos;
      if (url.includes("sortBy=releaseDate")) {
        videos.sort((a, b) => { return new Date(b.releaseDate) - new Date(a.releaseDate) })
        } else if (url.includes("sortBy=viewCount")) {
        videos.sort((a, b) => {
          return (b.viewCount) - (a.viewCount)
        })
        }
      setVideos(videos);
      setFilteredVideo(videos);
      
      if (url.includes(`title=${searchText}`)) {
        setFilteredVideo(videos.filter((a)=> { return a.title.toLowerCase().includes(searchText.toLowerCase())}))
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
      if (e.response.status !== 200) {
        setLoading(false)
        console.error(e);
      }
    }
    console.log(url);
  };

  const handleSearchInput = (e) => {
    let value = e.target.value;
    setSearchText(value);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    const timeOut = setTimeout(() => {
      fetchVideos()
    }, 1000);
    setDebounceTimeout(timeOut);

    
  };
  const sortByFunction = (e) => {
    setSortBy(e.target.value);
    fetchVideos();
    console.log(sortBy);
  };

  const handleActive = (val) => {
    setActiveGenres(true);
    setActiveRating([]);
    if (val === "all") {
      setActive([val]);
      setFilteredVideo(videos);
    } else {
      if (active.includes(val)) {
        setActive(active.filter((num) => num !== val));
        setFilteredVideo(filteredVideo.filter((num) => num.genre !== val));
      } else {
        let array = [...active, val];

        if (array.includes("all")) {
          setActive(array.filter((num) => num !== "all"));
          setFilteredVideo([]);
          let newData = [...videos];
          let found = newData.filter((item) => {
            return item.genre === val;
          });
          setFilteredVideo(found);
        } else {
          if (activeRating.length !== 0) {
            setFilteredVideo([]);
            setActiveRating([]);

            setActive(array);
            let newData = [...videos];
            let newfound = newData.filter((item) => {
              return item.genre === val;
            });
            setFilteredVideo([...newfound]);
          } else {
            setActive(array);
            let newData = [...videos];
            let newfound = newData.filter((item) => {
              return item.genre === val;
            });
            setFilteredVideo([...newfound, ...filteredVideo]);
          }
        }
      }
    }
  };
  if (active.length === 0) {
    setActive(["all"]);
    setFilteredVideo(videos);
  }

  const handleActiveRating = (val) => {
    setActive("all");
    if (activeRating.includes(val)) {
      setActiveRating(activeRating.filter((num) => num !== val));
      setFilteredVideo(
        filteredVideo.filter((num) => num.contentRating !== val)
      );
    } else {
      if (!active.includes("all")) {
        setFilteredVideo([]);
        setActiveRating(val);
        let newData = [...videos];
        let newfound = newData.filter((item) => {
          return item.contentRating === val;
        });
        setFilteredVideo([...newfound]);
      } else {
        if (activeGenres === true) {
          setActiveGenres(false);
          setFilteredVideo([]);
          setActiveRating(val);
          let newData = [...videos];
          let newfound = newData.filter((item) => {
            return item.contentRating === val;
          });
          setFilteredVideo([...newfound]);
        } else {
          setFilteredVideo([]);
          setActiveRating(val);
          let newData = [...videos];
          let newfound = newData.filter((item) => {
            return item.contentRating === val;
          });
          setFilteredVideo([...newfound]);
        }
      }
    }
  };
  useEffect(() => {
    fetchVideos();
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#FFFFFF",
      },
    },
  });

  const handleGenreSelectChange = (event) => {
    setSelectGenre(event.target.value);
  };
  const handleContentRatingSelectChange = (event) => {
    setSelectContentRating(event.target.value);
  };
  const handleChange = (newValue) => {
    setDateValue(newValue);
  };

  const handlevidLink = (e) => {
    setEnteredLink(e.target.value);
  };

  const handlevidThumbnail = (e) => {
    setEnteredThumbnail(e.target.value);
  };
  const handlevidTitle = (e) => {
    setEnteredTitle(e.target.value);
  };
  const handleOk = async (values) => {
    console.log(enteredLink);
    console.log(enteredTitle);
    console.log(selectContentRating);
    console.log(selectGenre);

    const date = moment(dateValue.format("DD MMM YYYY"));
    console.log(date._i);

    if (enteredLink === "" || selectGenre === "") {
      enqueueSnackbar("Please fill all fields", { variant: "error" });
    } else if (enteredTitle === "" || selectContentRating === "") {
      enqueueSnackbar("Please fill all fields", { variant: "error" });
    } else if (dateValue === "" || enteredThumbnail === "") {
      enqueueSnackbar("Please fill all fields", { variant: "error" });
    } else {
      setConfirmLoading(true);

      const res = await fetch(config.linked, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          videoLink: values["video-link"],
          title: enteredTitle,
          genre: selectGenre,
          contentRating: selectContentRating,
          releaseDate: date._i.toString(),
          previewImage: enteredThumbnail,
        }),
      })
        .then((res) => {
          setVisible(false);
          setConfirmLoading(false);

          return res.json();
        })
        .catch((error) => console.log(error));
      console.log(res);
    }
  };

  const SelectDate = styled(MobileDatePicker)({
    "label + &": {
      marginTop: 3,
      color: "#AFAFAF",
    },
    "& .MuiFormLabel-root": {
      color: "#AFAFAF",
    },

    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      border: "2px solid #5E5E5E",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      "&:focus": {
        borderRadius: 4,
        borderColor: "#5E5E5E",
      },
      width: "22rem",
      color: "#AFAFAF",
    },
    "& .MuiTypography-root": {
      color: "#AFAFAF",
    },
  });
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
    "&:hover": {
      backgroundColor: pink[700],
    },
  }));

  return (
    <div className="Home">
      <Header
        search={
          <Search
            className="searchBox"
            placeholder="Search"
            onChange={(e)=> {
              handleSearchInput(e)}}
            value={searchText}
            size="large"
            enterButton
            style={{
              margin: "auto",
            }}
          />
        }
        upload={
          <div>
            <Button
              className="upload"
              id="upload-btn"
              variant="contained"
              sx={{
                background: "#4CA3FC",
                borderRadius: "20px",
                fontWeight: "400",
              }}
              onClick={handleOpen}
              startIcon={<FileUploadIcon />}
            >
              Upload
            </Button>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div className="ModalHeader">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    marginBottom={2}
                    marginLeft={1}
                  >
                    Upload Video
                  </Typography>
                  <IconButton
                    className="closeModal"
                    sx={{ marginLeft: "auto" }}
                  >
                    <CloseIcon onClick={handleClose} sx={modalStyle} />
                  </IconButton>
                </div>
                <form>
                  <FormControl sx={{ mt: 1 }} name="video-link">
                    <div class="material-textfield">
                      <input
                        className="inputText"
                        placeholder=" "
                        value={enteredLink}
                        onChange={handlevidLink}
                        type="text"
                        required
                      />
                      <label className="labelTextbox">Video Link</label>
                    </div>
                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      This link will be used to derive the video
                    </FormHelperText>
                  </FormControl>
                  <FormControl name="thumbnail">
                    <div class="material-textfield">
                      <input
                        className="inputText"
                        placeholder=" "
                        value={enteredThumbnail}
                        onChange={handlevidThumbnail}
                        type="text"
                        required
                      />
                      <label className="labelTextbox">
                        Thumbnail Image Link
                      </label>
                    </div>

                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      This link will be used to preview the thumbnail image
                    </FormHelperText>
                  </FormControl>

                  <FormControl name="title">
                    <div class="material-textfield">
                      <input
                        className="inputText"
                        placeholder=" "
                        value={enteredTitle}
                        onChange={handlevidTitle}
                        type="text"
                        required
                      />
                      <label className="labelTextbox">Title</label>
                    </div>

                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      This title will be the representative text for the video
                    </FormHelperText>
                  </FormControl>
                  <FormControl name="genre">
                    <select
                      class="select-text"
                      value={selectGenre}
                      onChange={handleGenreSelectChange}
                      required
                    >
                      <option value="" disabled selected></option>
                      <option value={"Education"}>Education</option>
                      <option value={"Sports"}>Sports</option>
                      <option value={"Comedy"}>Comedy</option>
                      <option value={"Lifestyle"}>Lifestyle</option>
                    </select>
                    <span class="select-highlight"></span>
                    <span class="select-bar"></span>
                    <label class="select-label">Genre</label>

                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      Genre will help in categorizing videos
                    </FormHelperText>
                  </FormControl>
                  <FormControl name="age">
                    <select
                      class="select-text"
                      value={selectContentRating}
                      onChange={handleContentRatingSelectChange}
                      required
                    >
                      <option value="" disabled selected></option>
                      <option value={"Anyone"}>Anyone</option>
                      <option value={"7+"}>7+</option>
                      <option value={"12+"}>12+</option>
                      <option value={"16+"}>16+</option>
                      <option value={"18+"}>18+</option>
                    </select>
                    <span class="select-highlight"></span>
                    <span class="select-bar"></span>
                    <label class="select-label">
                      Suitable age group for the clip
                    </label>
                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      This will be used to filter videos on age group
                      suitability
                    </FormHelperText>
                  </FormControl>
                  <FormControl name="date">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <SelectDate
                        label="Release Date"
                        inputFormat="MM/DD/YYYY"
                        value={dateValue}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperText
                      sx={{ color: "#AFAFAF", marginBottom: "20px" }}
                    >
                      This will be used to sort videos based on Release Date
                    </FormHelperText>
                  </FormControl>
                  <ColorButton
                    variant="contained"
                    htmlType="submit"
                    id="upload-btn-submit"
                    loading={confirmLoading}
                    onClick={handleOk}
                  >
                    Upload Video
                  </ColorButton>
                  <ThemeProvider theme={theme}>
                    <Button
                      color="primary"
                      id="upload-btn-cancel"
                      className="cancel"
                      onClick={handleClose}
                    >
                      CANCEL
                    </Button>
                  </ThemeProvider>
                </form>
              </Box>
            </Modal>
          </div>
        }
      />
      <div className="filterMenu">
        {allGenres.map((allGenres) => {
          return (
            <span
              className={
                active.includes(allGenres.value)
                  ? "genre-btn active-filter"
                  : "genre-btn filter-btn"
              }
              onClick={() => {
                handleActive(allGenres.value);
              }}
            >
              {allGenres.label}
            </span>
          );
        })}
        <span className="sort-style" value={sortBy} onChange={sortByFunction}>
          <SwapVertIcon sx={{ color: "black" }} /> Sort By:{" "}
          <select className="sort-select sortDropdown">
            <option value="releaseDate" id="release-date-option" selected>
              Upload Date
            </option>

            <option value="viewCount" id="view-count-option">
              View Count
            </option>
          </select>
          <span></span>
          <span></span>
        </span>
      </div>
      <div className="filterMenuRatings">
        {allContentRatings.map((allContentRatings) => {
          return (
            <span
              className={
                activeRating.includes(allContentRatings.value)
                  ? "content-rating-btn active-filter"
                  : "content-rating-btn filter-btn"
              }
              onClick={() => handleActiveRating(allContentRatings.value)}
            >
              {allContentRatings.label}
            </span>
          );
        })}
      </div>
      <div className="dashboardContainer">
        {loading ? (
          <div className="loadingScreen">
            <CircularProgress />
          </div>
        ) : (filteredVideo.length > 0 ? 
          <Grid container spacing={2}>
            {" "}
            {filteredVideo.map((video, key) => {
              return (
                <Grid item xs={12} sm={6} md={3} key={video._id}>
                  <Dashboard data={video} />
                </Grid>
              );
            })}
          </Grid> : <div className="NoDataFound">No videos found</div>
        )}
      </div>
    </div>
  );
};

export default Home;
